// extracted by mini-css-extract-plugin
export var divider = "_no-0";
export var systemMessage = "_no-1";
export var systemMessageWrapper = "_no-2";